module.exports = __webpack_public_path__ + "static/img/3394_phase_function_Paper_Points.908e053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3394_phase_function_Paper_Points.png
// module id = bCaU
// module chunks = 0